<div class="container" *ngIf="settings">

    <!-- estimated duration -->
    <h3>{{'tablesPlan.settings.estimatedDuration' | translate}}</h3>

    <hr>

    <div class="d-grid gap-1">
        <div class="form-group d-flex justify-content-between align-items-center">
            <label class="label">{{'tablesPlan.settings.oneToTwoCovers' | translate}}</label>
            <div class="d-flex flex-fill">
                <input type="number" class="duratio form-control" [(ngModel)]="oneToTwoCoversHours">
                <input type="number" class="duratio form-control ms-1" [(ngModel)]="oneToTwoCoversMinutes">
            </div>
        </div>
        <div class="form-group d-flex justify-content-between align-items-center">
            <label class="label">{{'tablesPlan.settings.threeToFourCovers' | translate}}</label>
            <div class="d-flex flex-fill">
                <input type="number" class="duratio form-control" [(ngModel)]="threeToFourCoversHours">
                <input type="number" class="duratio form-control ms-1" [(ngModel)]="threeToFourCoversMinutes">
            </div>
        </div>
        <div class="form-group d-flex justify-content-between align-items-center">
            <label class="label">{{'tablesPlan.settings.fiveOrMoreCovers' | translate}}</label>
            <!-- <input type="number" class="duratio form-control" [(ngModel)]="settings.fiveOrMoreCoversDuration"> -->
            <div class="d-flex flex-fill">
                <input type="number" class="duratio form-control" [(ngModel)]="fiveOrMoreCoversHours">
                <input type="number" class="duratio form-control ms-1" [(ngModel)]="fiveOrMoreCoversMinutes">
            </div>
        </div>
    </div>

    <hr>

    <!-- arrival time notification -->
    <!-- <div class="form-group d-flex justify-content-between align-items-center">
        <label class="d-flex flex-column label">
            <span>{{'tablesPlan.settings.settingsArrivalTimeAlarm' | translate}}</span>
            <span>{{'tablesPlan.settings.minutes' | translate}}</span>
        </label>
        <input type="number" class="duratio form-control flex-fill" [(ngModel)]="settings.arrivalTimeAlarmNotification">
    </div>

    <hr> -->

    <!-- attendance rate -->
    <!-- <div class="form-group d-flex justify-content-between align-items-center">
        <label class="d-flex flex-column label">
            <span>{{'tablesPlan.settings.settingsAttendanceRate' | translate}}</span>
            <span>{{'tablesPlan.settings.visitorsPerFifteenMinutes' | translate}}</span>
        </label>
        <input type="number" class="duratio form-control" [(ngModel)]="settings.attendanceRate">
    </div>

    <hr> -->

    <!-- shifts -->
    <h3><i class="bi bi-clock-history"></i>{{'tablesPlan.settings.shifts' | translate}}</h3>

    <table class="w-100 shifts-table">
        <tbody>
            @for (shift of shifts; track $index) {
            <tr>
                <td class="pe-2">
                    <div class="form-group d-flex align-items-center gap-2">
                        <!-- <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="shift.isActive">
                            <label class="form-check-label">{{getTitle(shift.type) | translate}}</label>
                        </div> -->
                        <!-- <app-checkbox [model]="shift.isActive" (modelChange)="setShiftIsActive($event)"></app-checkbox> -->
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="shift.isActive">
                            <label class="form-check-label">{{getTitle(shift.type) | translate}}</label>
                        </div>
                    </div>
                </td>
                <td class="ps-2 pe-2">
                    <div class="form-group inline d-flex justify-content-center align-items-center gap-2">
                        <label class="fixed-width">{{'tablesPlan.settings.from' | translate}}:</label>
                        <div class="d-flex align-items-center gap-1">
                            <select class="form-control" [(ngModel)]="shift.fromHour">
                                <option *ngFor="let h of hours" [ngValue]="h">{{h < 10 ? "0" + h : h}}</option>
                            </select>
                            <b>: </b>
                            <select class="form-control" [(ngModel)]="shift.fromMin">
                                <option *ngFor="let m of mins" [ngValue]="m">{{m < 10 ? "0" + m : m}}</option>
                            </select>
                        </div>

                    </div>
                </td>
                <td class="ps-2">
                    <div class="to-hour-nowrap form-group inline d-flex justify-content-end align-items-center gap-2">
                        <label class="fixed-width">{{'tablesPlan.settings.to' | translate}}:</label>
                        <div class="d-flex align-items-center gap-1">
                            <select class="form-control" [(ngModel)]="shift.toHour">
                                <option *ngFor="let h of hours" [ngValue]="h">{{h < 10 ? "0" + h : h}}</option>
                            </select>
                            <b>: </b>
                            <select class="form-control" [(ngModel)]="shift.toMin">
                                <option *ngFor="let m of mins" [ngValue]="m">{{m < 10 ? "0" + m : m}}</option>
                            </select>
                        </div>

                    </div>
                </td>
            </tr>
            <tr class="to-hour-wrap">
                <td class="pe-2"></td>
                <td class="to-hour-cell ps-2 pe-2">
                    <div class="form-group inline d-flex justify-content-center align-items-center gap-2">
                        <label class="fixed-width">{{'tablesPlan.settings.to' | translate}}:</label>
                        <div class="d-flex align-items-center gap-1">
                            <select class="form-control" [(ngModel)]="shift.toHour">
                                <option *ngFor="let h of hours" [ngValue]="h">{{h < 10 ? "0" + h : h}}</option>
                            </select>
                            <b>: </b>
                            <select class="form-control" [(ngModel)]="shift.toMin">
                                <option *ngFor="let m of mins" [ngValue]="m">{{m < 10 ? "0" + m : m}}</option>
                            </select>
                        </div>

                    </div>
                </td>
                <td class="ps-2"></td>
            </tr>
            }
        </tbody>
    </table>

    <hr>

    <!-- country code -->
    <div class="form-group d-flex justify-content-between align-items-center flex-wrap">
        <label class="d-flex flex-column label">
            {{'tablesPlan.settings.countryCode' | translate}}
        </label>
        <app-dropdown [(model)]="settings['smsDefaultCountryCode ']" [items]="counttryCodes"
            [displayProperty]="'display'" [valueProperty]="'value'" class="flex-fill">
        </app-dropdown>
    </div>

    <div class="d-flex justify-content-center gap-2 mt-4">
        <button class="btn btn-sec flex-fill" (click)="cancel()">{{'common.buttons.cancel' | translate}}</button>
        <button class="btn btn-main flex-fill" (click)="save()">{{'common.buttons.set' | translate}}</button>
    </div>

</div>

<div #toast class="toast position-fixed bottom-0 start-50 translate-middle-x text-bg-danger z-2" role="alert" aria-live="assertive" aria-atomic="true"
    data-bs-config='{"delay":2500, "autohide": true, "animation": true}'>
    <div class="toast-body text-center">
      <p>{{message}}</p>
    </div>
</div>